'use strict';

/**
* Creates an error notification and appends it to the error messaging container
* @param {string} alertHtml - HTML content for the error notification
* @returns {void}
*/
function createErrorNotification(alertHtml) {
    $('.error-messaging').append(alertHtml);
}
/**
 * Ajax Call to edit optin profile preferences
 */
function accountPreferences() {
    $('body').on('submit', '#profile-optin-form', function (e) {
        e.preventDefault();
        var $form = $('form.profile-preferences');
        var url = $form.attr('action');
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'post',
            data: $form.serialize(),
            success: function (returnedData) {
                $(this).spinner().stop();
                if (returnedData.success) {
                    $('body').trigger('newsletter:subscription', returnedData);
                    window.location.href = returnedData.redirectUrl;
                }
            },
            error: function (response) {
                createErrorNotification(response.responseText);
                $(this).spinner().stop();
            }
        });
    });
}

/**
 * Initializes the custom switch checkboxes
 * @returns {void}
 */
function initCheckboxes() {
    $('.custom-switch>input').on('change', function () {
        $(this).val(this.checked);
    });
}
module.exports = { accountPreferences: accountPreferences, initCheckboxes: initCheckboxes };
